export default __webpack_public_path__ + "static/45-9842aeab36d1940a44927eb04fa09688.png";